import { Any } from "../fakeTypes";

export type Ledger = {
  id: string; // string id of the ledger entry, e.g. an order id
  refid?: string; // string id of the ledger entry, e.g. a withdrawal id
  depId?: string; // string id of the ledger entry, e.g. a withdrawal id
  direction: "in" | "out"; // 'out' or 'in'
  account?: string; // string id of the account if any
  referenceId: string; // string id of the trade, transaction, etc...
  referenceAccount?: string; // string id of the opposite account (if any)
  type: string; // string, reference type, see below
  currency: string; // string, unified currency code, 'ETH', 'USDT'...
  amount: number; // absolute number, float (does not include the fee)
  timestamp: number; // milliseconds since epoch time in UTC
  datetime: string; // string of timestamp, ISO8601
  before?: number; // amount of currency on balance before
  after: number; // amount of currency on balance after
  status: string; // 'ok, 'pending', 'canceled'
  txid?: string; // string, transaction id (if any)
  network?: string; // string, network id (if any)
  fee: {
    // object or or undefined
    cost: number; // absolute number on top of the amount
    currency: string; // string, unified currency code, 'ETH', 'USDT'...
  };
  info: Any; // raw ledger entry as is from the exchange
};
